module.exports = __webpack_public_path__ + "static/images/backpack2.fbecb7b.png";